/**Dependencies */
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { calculateBookingDates } from '../helpers';

/**Components */
import { Swiper, SwiperSlide } from "swiper/react";
import { elementoPorSeccion } from '../services/adminProductService';
import { Navigation } from 'swiper/modules';

/**Images */
import { IoIosArrowForward, IoIosArrowBack } from "react-icons/io";
import apiClient from '../utils/apiClient';

import "../styles/nefertaricarousel.scss";

export const NefertariCarousel = (idElemento) => {

    const [toursNefertari, setToursNefertari] = useState([]);
    const [imgsBanners, setImgsBanners] = useState([]);
    const { checkIn, checkOut } = calculateBookingDates();


    useEffect(() => {
        const fetchElemento = async () => {
            try {
                const response = await apiClient.get(
                    `https://nefertaritravel.com.mx/wp-json/nexora/v1/get-tours/?destino=salidas-garantizadas`
                );
                console.log(response.data)
                if(response?.data){
                    setToursNefertari(response.data)
                }
            } catch (e) {
                throw new Error("error connection", e);
            }
        };

        fetchElemento();
        console.log(toursNefertari)

    }, [idElemento]);

    return (
        <div className='container py-5'>
            <div className="text-center mb-5">
                <h1 className='section-title'>Circuitos Internacionales</h1>
            </div>
            <div className="slider-container carousel-container pb-5">
                <div className="custom-prev" id='prev-hotels'><IoIosArrowBack /></div>
                <Swiper
                    navigation={{
                        nextEl: '#next-hotels',
                        prevEl: '#prev-hotels',
                    }}
                    spaceBetween={8}
                    slidesPerView={1}
                    loop={true}
                    autoplay={{ delay: 3000 }}
                    modules={[Navigation]}
                    breakpoints={{
                        640: {
                            slidesPerView: 1,

                        },
                        768: {
                            slidesPerView: 2,

                        },
                        1024: {
                            slidesPerView: 3.5,

                        },
                    }}
                >
                    {toursNefertari?.map((tour, index) => (
                        <SwiperSlide key={index}>
                            <div className="swiper-slide">
                                <div className="nf-card">
                                    <div className="nf-badge" style={{ background: "#FF5C33"}}>
                                        <span className="nf-badge-item">
                                            {tour.dias} días
                                        </span>
                                        <span className="nf-badge-divider"></span>
                                        <span className="nf-badge-item">
                                            {tour.noches} noches
                                        </span>
                                    </div>

                                    <div className="nf-img" style={{ "background-image": `url('${tour.imagen}')` }}></div>
                                    <div className="nf-content">
                                        <h3 className="nf-title">{tour.titulo}</h3>
                                        <span className="nf-label" style={{"color": "#FF5C33"}}>VISITANDO</span>
                                        <p className="nf-visit">{tour.visitando}</p>
                                    </div>
                                    <div className="nf-footer">
                                        <span className="nf-desde">Desde</span>
                                        <div className="nf-price-box">
                                            <span className="nf-price">${tour.desde ? parseInt(tour.desde).toLocaleString() : '---'} <small style={{"color": "#FF5C33" }}> USD</small></span>
                                            {tour.impuestos ? <span className="nf-tax" style={{ "color": "#FF5C33" }}> + ${tour.impuestos ? parseInt(tour.impuestos).toLocaleString() : null} USD</span> : ''}
                                        </div>
                                    </div>
                                    <a href={`https://iframe.nefertaritravel.com.mx/viaje/${tour.slug}?cp=FF5C33&moneda=USD`} target="_blank" className="nf-link"></a>
                                </div>
                            </div>
                        </SwiperSlide>

                    ))}
                </Swiper>
                <div className="custom-next" id='next-hotels'><IoIosArrowForward /></div>
            </div>
        </div>
    )
}
